import { EventTriggerFixed, IEventTrigger, Provider } from 'services/Analytics/core';
import { getAbAutoTestsParams } from 'services/Firebase/helpers';
import { AbAutoTestsParamsReturnValue } from 'services/Firebase/utils/types';

export const changePathNameToScreenId = (pathName = window.location.pathname) => {
    const screenId = pathName.replace(/^\/|\/$/g, '').replace(/(\/([a-z]{2})\/)|\//g, '_');

    return screenId || 'log_in';
};

export const getAbTestName = ({
    experiment,
    variantName,
}: Pick<AbAutoTestsParamsReturnValue, 'experiment' | 'variantName'>) => `${experiment}__${variantName}`;

export const selectAbTestName = ({
    experiment,
    variantName,
}: Pick<AbAutoTestsParamsReturnValue, 'experiment' | 'variantName'>) => {
    const { aqa, ...autoTestParams } = getAbAutoTestsParams();

    return aqa ? getAbTestName(autoTestParams) : getAbTestName({ experiment, variantName });
};

export const setIdToTheProvider = (id: number | null) => id && Provider.setCoreId(id);

export const getEventSchemaKey = (event: EventTriggerFixed | IEventTrigger) => {
    const eventName = typeof event === 'string' ? event : `${event.screenId}__${event.event}`;

    return `iglu:com.welltech.yoga_go.web/${eventName}/jsonschema/1-2-0`;
};
